<template>
  <aside class="admin-sidebar" :class="{ 'admin-sidebar--closed' : closed }">
    <slot></slot>
  </aside>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['closed'],
};
</script>
